import {SCORE_MODEL_ID, LESSON_LOCATION_MODEL_ID, LESSON_STATUS_MODEL_ID} from "scorm/scorm_1_2/ScoData";
import {Assert} from "common/Assert";

export function createProfileControllerApi( course ) {

    Assert.checkArgument( course );

    // revealing public api
    return {

        /**
         * Gets the storage method for the course.
         *
         * @returns {String} storage method
         */
        getStorageMethod: function () {
            return "jsapi";
        },

        /**
         * @deprecated
         * @param {String} scoId
         * @returns {Number}
         */
        getMasteryScore: function (scoId) {
            return course.domStructure.getSequenceData( scoId ).getMasteryScore() || 80;
        },

        getScore: function (scoId) {
            const score = Number( course.getLearningScoValue( scoId, SCORE_MODEL_ID ) );
            return isNaN( score ) ? 0 : score;
        },

        getLessonStatus: (scoId) => course.getLearningScoValue(scoId,LESSON_STATUS_MODEL_ID) || "unknown",
        getLessonLocation: (scoId) => course.getLearningScoValue(scoId,LESSON_LOCATION_MODEL_ID) || "unknown",

        // ToDo: Check with UI tests if necessary, return false when not.
        canResume: function (scoId) {

            const lessonStatus = course.getLearningScoValue(scoId,LESSON_STATUS_MODEL_ID),
                lessonLocation = course.getLearningScoValue(scoId,LESSON_LOCATION_MODEL_ID);

            return lessonLocation && (lessonStatus !== "na") && (lessonStatus !== "unknown");
        },

        setUsername: function (name) {
            course.username = name;
        },

        getUsername: function () {
            return course.username;
        }
    };
}
